import DatePicker from "vue2-datepicker";
import moment from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import StoreGetter from "@/constants/StoreGetter";
import Settings from "../../../constants/Settings";
import { PayrollTrial } from "@/model/PayrollTrial";
import { datePickerLang } from "@/constants/globalConstants";
import PayGroupService from "@/service/PayGroupService";
import PayrollTrialService from "@/service/PayrollTrialService";
import ArrayHelper from "../../../common/helper/ArrayHelper";
import SweetAlertService from "../../../service/SweetAlertService";
import CompanyService from "@/service/CompanyService";
import ReportService from "@/service/ReportService";
export default {
  components: {
    DatePicker,
    moment
  },
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    showExportAutopayBtn() {
      return (
        this.showTrialDtl.reduce((total, trial) => {
          return total + trial.Details.length;
        }, 0) > 0
      );
    },
    editMode() {
      return this.selectMode == "Edit";
    },
    AdjustmentsList() {
      const chk = this.AdjustmentChk;
      let list = this.AdjustmentItemList;
      const reverse = this.reverse;
      const sortKey = this.sortKey;
      let Datas = [];
      let SystemList = [],
        ManualList = [];
      if (chk.indexOf("Add") > -1) {
        const Data = list.filter(x => x.AdjAdd);
        Datas = Datas.concat(Data);
      }
      if (chk.indexOf("Deduct") > -1) {
        const Data = list.filter(x => !x.AdjAdd);
        Datas = Datas.concat(Data);
      }
      Datas = ArrayHelper.uniqueBykey(Datas, "DateTx");

      if (chk.indexOf("System") > -1) {
        SystemList = Datas.filter(x => x.SysGen);
      }
      if (chk.indexOf("Manual") > -1) {
        ManualList = Datas.filter(x => !x.SysGen);
      }
      Datas = SystemList.concat(ManualList);
      ArrayHelper.sortByKey(Datas, sortKey, reverse);
      return Datas;
    }
  },
  data() {
    return {
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Settings.MenuID.PayrollTrial,
      Settings: Settings,
      dictEnum: dictEnum,
      lang: datePickerLang,
      trialStatus: Settings.PayrollStatus.New,
      trialStatusList: [
        {
          id: Settings.PayrollStatus.New,
          value: t.t(dictEnum.LBL_New)
        },
        {
          id: Settings.PayrollStatus.Approving,
          value: t.t(dictEnum.LBL_Pending)
        },
        {
          id: Settings.PayrollStatus.Approved,
          value: t.t(dictEnum.LBL_Approved)
        },
        {
          id: Settings.PayrollStatus.Released,
          value: t.t(dictEnum.LBL_Released)
        },
        {
          id: Settings.PayrollStatus.Closed,
          value: t.t(dictEnum.LBL_Closed)
        },
        {
          id: Settings.PayrollStatus.Rejected,
          value: t.t(dictEnum.LBL_Rejected)
        }
      ],
      trialStatus: "",
      hideHdrMode: false,
      selectedRecord: {},
      selectedDtl: {},
      trialList: [],
      trialField: [
        {
          key: "DateVal",
          label: t.t(dictEnum.LBL_Month)
        },
        {
          key: "TimeBetween",
          label: t.t(dictEnum.LBL_Date)
        },
        {
          key: "TotAmt",
          label: t.t(dictEnum.LBL_Salary)
        },
        {
          key: "PayGrpCode",
          label: t.t(dictEnum.LBL_PayGroup)
        },
        {
          key: "Status",
          label: t.t(dictEnum.LBL_Status)
        }
      ],
      company: "",
      compList: [],
      hideTrialField: [
        {
          key: "DateVal",
          label: t.t(dictEnum.LBL_Month)
        }
      ],
      currentPage: 1,
      perPage: 15,
      modelList: {
        edit: "Edit",
        view: "View"
      },
      selectMode: "View",
      payGroupList: [],
      payrollTrialDetail: [],
      showTrialDtl: [],
      messageList: [],
      selectedMsg: {},
      AdjustmentChk: [],
      AdjustmentTypeList: [],
      AdjustmentItemList: [],
      printModel: [],
      PrintList: [
        {
          id: "Bank",
          text: t.t(dictEnum.LBL_BankAutopay)
        },
        {
          id: "MPF",
          text: t.t(dictEnum.LBL_MPF)
        }
      ],
      sortKey: "",
      reverse: false,
      AdjustmentTHs: [
        {
          id: "DateTx",
          label: t.t(dictEnum.LBL_Date),
          class: "text-center"
        },
        {
          id: "Particulars",
          label: t.t(dictEnum.LBL_Particular),
          class: ""
        },
        {
          id: "AdjAdd",
          label: "+/-",
          class: ""
        },
        {
          id: "Amt",
          label: t.t(dictEnum.LBL_Amount),
          class: "text-right"
        },
        {
          id: "SysGen",
          label: t.t(dictEnum.LBL_Src),
          class: ""
        }
      ],
      lang: this.$store.getters[StoreGetter.user].Lang,
      staffAttendance: [],
      startDay: "",
      endDay: ""
    };
  },

  mounted() {
    this.assignRights();
    this.getPayGroupList();
    this.getCompList();
    this.getPayrollHdrList();
    // this.getStaffAttendance();
  },

  methods: {
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];

      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },

    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (
        item.TxNum == this.selectedRecord.TxNum &&
        item.Status == this.selectedRecord.Status
      ) {
        return "selected-tr";
      }
    },

    DateBetween(item) {
      if (item) {
        let startDay = moment(item.PayDateFrom)
          .startOf("month")
          .format("DD/MM");
        this.startDay = moment(item.PayDateFrom)
          .startOf("month")
          .format(Settings.DateTime.yyyymmdd);
        let endDay = moment(item.PayDateTo)
          .endOf("month")
          .format("DD/MM");
        this.endDay = moment(item.PayDateTo)
          .endOf("month")
          .format(Settings.DateTime.yyyymmdd);
        return `${startDay} - ${endDay}`;
      }
    },

    CountNumber(list, key) {
      let number = list.reduce((prev, cur) => {
        return prev + cur[key];
      }, 0);
      return number ? number : 0;
    },

    PayGroupName(payGroupId) {
      const find = this.payGroupList.find(x => x.Grp == payGroupId);
      if (find) {
        return find.GrpDesc;
      }
    },

    compName(comp) {
      const find = this.compList.find(x => x.CompCode == comp);
      if (find) {
        return this.user.Lang == "EN" ? find.EName : find.CName;
      }
    },
    async getCompList() {
      var obj = {
        take: 100,
        skip: 0
      };
      const response = await CompanyService.getAllCompanyList(obj);
      if (response.data.IsSuccess) {
        this.compList = response.data.Data.Item1;
        this.comp = response.data.Data.Item1[0].CompCode || "";
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    StatusName(statusID) {
      const find = this.trialStatusList.find(x => x.id == statusID);
      if (find) {
        return find.value;
      }
    },

    initData() {
      this.selectMode = this.modelList.edit;
      this.selectedRecord = {};
      this.payrollTrialDetail = [];
      this.showTrialDtl = [];
      this.messageList = [];
    },

    async getPayGroupList() {
      var obj = {};
      const response = await PayGroupService.getAllPayGroup(obj);
      if (response.data.IsSuccess) {
        this.payGroupList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    ActualPayment(item) {
      let num = 0;
      item.Details.forEach(x => {
        num = num + this.Netprofit(x);
      });
      return num;
    },

    TotalActual() {
      let num = 0;
      if (this.showTrialDtl.length > 0) {
        this.showTrialDtl.forEach(x => {
          num = num + this.ActualPayment(x);
        });
      }
      return num;
    },

    CopeWith(item) {
      let num = 0;
      item.Details.forEach(x => {
        num = num + this.Netprofit(x) + x.EmployerMPF;
      });
      return num;
    },

    TotalCopeWith() {
      let num = 0;
      if (this.showTrialDtl.length > 0) {
        this.showTrialDtl.forEach(x => {
          num = num + this.CopeWith(x);
        });
      }
      return num;
    },

    Netprofit(item) {
      let num = 0;
      num = item.Netprofit;
      return num;
    },

    // async getStaffAttendance() {
    //   //inclSubordinate can show all staff record
    //   const obj = {
    //     userId: this.user.UserID,
    //     dateStart: this.startDay,
    //     dateEnd: this.endDay,
    //     inclSubordinate: 1,
    //     compCode: this.company
    //   };

    //   const response = await ReportService.getStaffAttendance(obj);
    //   if (response.data.IsSuccess) {
    //     response.data.Data = ArrayHelper.sortByKey(response.data.Data, "Date");
    //     const data = response.data.Data;
    //     this.staffAttendance = data;
    //     console.log(" this.staffAttendance", this.staffAttendance);
    //   } else {
    //     //SweetAlertService.warning("Warn", response.data.Message);
    //   }
    // },

    async getPayrollHdrList() {
      var obj = {
        payrollComp: this.company,
        status: this.trialStatus
      };
      const response = await PayrollTrialService.getPayrollHdrList(obj);
      if (response.data.IsSuccess) {
        ArrayHelper.sortByKey(response.data.Data, "DateVal", false);
        this.trialList = response.data.Data;
        if (
          this.selectedRecord &&
          !this.trialList.some(
            trial => trial.TxNum === this.selectedRecord.TxNum
          ) &&
          this.$refs.Table
        ) {
          this.$refs.Table.clearSelected();
        }
        this.initData();
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async changeCompList() {
      await this.getPayrollHdrList();
      if (this.company === "") {
        this.showTrialDtl = this.payrollTrialDetail;
        return;
      }
      this.showTrialDtl = this.payrollTrialDetail.map(item => {
        return {
          ...item,
          Details: item.Details.filter(
            cItem =>
              cItem.Id.toLowerCase().indexOf(this.company.toLowerCase()) === 0
          )
        };
      });
    },

    updateMode(mode) {
      this.selectMode = mode;
    },

    addPayTrialPopupShow() {
      this.$bvModal.show("payrollTrialShow");
      this.selectedRecord = {};
    },

    async addPayrollTrial() {
      this.updateMode(this.modelList.edit);
      let obj = {
        date: moment(this.selectedRecord.Date).format(
          Settings.DateTime.yyyymmdd
        ),
        group: this.selectedRecord.PayGroup,
        payrollComp: this.selectedRecord.CompCode
      };
      const response = await PayrollTrialService.savePayrollTrialItem(obj);
      if (response.data.IsSuccess) {
        this.selectedRecord = response.data.Data;
        this.getPayrollHdrList();
        SweetAlertService.success("Success", response.data.Message);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    editPayrollTrial() {
      this.updateMode(this.modelList.edit);
    },

    AdditionItemShow(item) {
      item.additionShow = !item.additionShow;
    },

    DeductItemShow(item) {
      item.deductShow = !item.deductShow;
    },

    clickHideHdr() {
      this.hideHdrMode = !this.hideHdrMode;
    },

    async deletePayrollTrial() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: `${t.t(dictEnum.WARN_Delete)}`,
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const response = await PayrollTrialService.deletePayrollTrial(
          this.selectedRecord.TxNum
        );
        if (response.data.IsSuccess) {
          this.getPayrollHdrList();
          this.updateMode(this.modelList.view);
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },

    async ExportAutopay() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: this.t.t(dictEnum.MSG_ExportFile),
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);

      if (result.value) {
        var obj = {
          txNum: this.selectedRecord.TxNum
        };
        const response = await PayrollTrialService.exportAutopayFiles(obj);
        if (response.data.IsSuccess) {
          let list = response.data.Data;
          // list.forEach(x => {
          //   x.DateJoin = moment(x.DateJoin).format(Settings.DateTime.yyyymmdd);
          // });
          var XLSX = require("xlsx");
          var worksheet = XLSX.utils.json_to_sheet(list, false);
          let workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet);
          XLSX.writeFile(
            workbook,
            "Autopay" +
              "_" +
              moment().format(Settings.DateTime.yyyymmddhhmmss) +
              ".xlsx"
          );
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },

    async ExportTableData() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: this.t.t(dictEnum.MSG_ExportFile),
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        let list = [];
        for (const i in this.showTrialDtl) {
          const data = this.showTrialDtl[i];
          list = list.concat(data.Details);
        }
        list.forEach(x => {
          x.DateJoin = moment(x.DateJoin).format(Settings.DateTime.yyyymmdd);
        });
        var XLSX = require("xlsx");
        var worksheet = XLSX.utils.json_to_sheet(list, false);
        let workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet);
        XLSX.writeFile(
          workbook,
          "PayrollTrial" +
            "_" +
            moment().format(Settings.DateTime.yyyymmddhhmmss) +
            ".xlsx"
        );
      }
    },

    ClickPrintModal() {
      this.$bvModal.show("PrintModal");
    },

    async clickPrint() {
      const obj = this.printModel;
      const response = await PayrollTrialService.printPayrollTrial(obj);
      if (response.data.IsSuccess) {
        SweetAlertService.success("Success", response.data.Message);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async OnPayrollTrialSelect(item) {
      console.log("selected: ", item);
      item.DateVal = moment(item.DateVal).format(Settings.DateTime.yyyymm);
      this.selectedRecord = item;
      let obj = {
        txNum: this.selectedRecord.TxNum
      };
      const response = await PayrollTrialService.getPayrollTrialDtl(obj);
      if (response.data.IsSuccess) {
        response.data.Data.forEach(x => {
          x.additionShow = false;
          x.deductShow = false;
          let addList = [],
            deductList = [];
          for (const detail of x.Details) {
            addList = addList.concat(detail.AddWages);
          }
          if (addList.length > 0) {
            x.AddHeads = addList.map(w => w.Particulars);
          }
          for (const detail of x.Details) {
            deductList = deductList.concat(detail.DeductWages);
          }
          if (deductList.length > 0) {
            x.DeductHeads = deductList.map(w => w.Particulars);
          }
        });
        this.payrollTrialDetail = response.data.Data;
        this.showTrialDtl = response.data.Data;
        this.updateMode(this.modelList.view);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
      this.getTrialMessage();
    },

    async getTrialMessage() {
      if (!this.selectedRecord.TxNum) return;
      const obj = {
        txNum: this.selectedRecord.TxNum
      };
      const response = await PayrollTrialService.getPayrollTrialMsg(obj);
      if (response.data.IsSuccess) {
        this.messageList = response.data.Data;
        this.selectedMsg = {};
        ArrayHelper.sortByKey(this.messageList, "DateAdd", false);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    showTrialMessage() {
      this.$bvModal.show("messageShow");
      this.selectedMsg = this.messageList[0];
    },

    CountAdjuctment() {
      let num = 0;
      for (const i in this.AdjustmentsList) {
        const data = this.AdjustmentsList[i];
        if (data.AdjAdd) {
          num = num + data.Amt;
        } else {
          num = num - data.Amt;
        }
      }
      return num;
    },

    showAdjustmentClick(item) {
      this.$bvModal.show("adjustmentShow");
      this.selectedDtl = item;
      this.AdjustmentTypeList = [
        {
          id: "Add",
          value: t.t(dictEnum.LBL_Addition)
        },
        {
          id: "Deduct",
          value: t.t(dictEnum.LBL_Deduct)
        },
        {
          id: "System",
          value: t.t(dictEnum.LBL_System)
        },
        {
          id: "Manual",
          value: t.t(dictEnum.LBL_Manual)
        }
      ];
      this.AdjustmentChk = this.AdjustmentTypeList.map(x => x.id);
      this.AdjustmentItemList = item.AddWages.concat(item.DeductWages);
    },

    sortByAdjustment(sortKey) {
      this.reverse = this.sortKey == sortKey ? !this.reverse : false;

      this.sortKey = sortKey;
    },

    async submitPayTrial() {
      const sweetAlertOptions = {
        title: this.t.t(dictEnum.WARN_Confirm),
        text: this.t.t(dictEnum.BTN_Submit),
        cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
        confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
      };
      const result = await SweetAlertService.question(sweetAlertOptions);
      if (result.value) {
        const obj = {
          txNum: this.selectedRecord.TxNum
        };
        const response = await PayrollTrialService.sendPayrollTrialItem(obj);
        if (response.data.IsSuccess) {
          this.getPayrollHdrList();
          SweetAlertService.success("Success", response.data.Message);
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },

    clickMsg(item) {
      this.selectedMsg = item;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/100000-Payroll/101000-PayrollTrial/101000-PayrollTrial.js